/**
 * add comma as a thousands separator to a number
 */
function numberWithCommas(num: number): string {

  if(num) return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return '0'
}

export {
  numberWithCommas,
};
